import { EmptyState } from '@repo/common/components';
import { observer } from 'mobx-react-lite';
import { BiMetricPageController } from '../../features/BiMetric/BiMetricPageController.tsx';
import { useFeatureFlags } from '../../utils/featureFlags';
import { useParamsIdSuffixUuid } from '../../utils/hook/utils';

function BiMetricPage() {
	const id = useParamsIdSuffixUuid();
	const { biDashboardsEnabled } = useFeatureFlags();

	if (!biDashboardsEnabled) {
		return (
			<EmptyState
				title="BI Metrics are not enabled"
				description="Please contact your administrator to enable BI Metrics"
				illustrationName="upgrade"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
			/>
		);
	}

	return <BiMetricPageController metricId={id} mode="page" />;
}

const ObservedBiMetricPage = observer(BiMetricPage);
export default ObservedBiMetricPage;
